import { render, staticRenderFns } from "./Fc.vue?vue&type=template&id=5c8ec928&scoped=true&lang=pug&"
import script from "./Fc.vue?vue&type=script&lang=coffee&"
export * from "./Fc.vue?vue&type=script&lang=coffee&"
import style0 from "./Fc.vue?vue&type=style&index=0&id=5c8ec928&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ec928",
  null
  
)

export default component.exports